<template>
  <div class="generalLogin">
    <div class="tabs" v-if="showTab">
      <span>输入乘机人信息</span>
      <span @click="enterClick">扫描乘机信息</span>
    </div>
    <div class="login-input">
      <van-field
        v-model="queryNo"
        name="queryNo"
        class="cell"
        clearable
        @focus="onFocus"
        @blur="onBlur"
      />
      <div :class="placeholderClass('queryNo')">证件号或者票号</div>
      <div v-if="showHandleName === 'queryNo'" class="handle-list">
        <div
          v-for="(item, index) in queryNoList"
          :key="index"
          @click.stop="clickCacheItem('queryNo', item)"
        >{{item}}</div>
      </div>
    </div>
    <van-row class="name-group" type="flex" align="bottom" justify="space-between">
      <div class="login-input">
        <van-field
          v-model="familyName"
          name="familyName"
          class="cell"
          clearable
          @focus="onFocus"
          @blur="onBlur"
        />
        <div :class="placeholderClass('familyName')">乘机人的姓氏</div>
        <div v-if="showHandleName === 'familyName'" class="handle-list">
          <div
            v-for="(item, index) in familyNameList"
            :key="index"
            @click.stop="clickCacheItem('familyName', item)"
          >{{item}}</div>
        </div>
      </div>
      <div class="split">
        <b>/</b>
      </div>
      <div class="login-input">
        <van-field
          v-model="givenName"
          name="givenName"
          class="cell"
          clearable
          @focus="onFocus"
          @blur="onBlur"
        />
        <div :class="placeholderClass('givenName')">乘机人的名字</div>
        <div v-if="showHandleName === 'givenName'" class="handle-list">
          <div
            v-for="(item, index) in givenNameList"
            :key="index"
            @click.stop="clickCacheItem('givenName', item)"
          >{{item}}</div>
        </div>
      </div>
    </van-row>
    <van-button
      :disabled="btnDisabled"
      class="qry-btn"
      block
      round
      type="info"
      @click="queryClick"
    >查 询</van-button>
    <div class="tip" v-if="$route.query.channel === 'upgrades'">
      温馨提示:
      <van-icon name="question" @click="openDescClick" />
      <br />升舱成功后，可通过南航APP获取原客票及升舱差价电子发票。
    </div>
    <div class="tip" v-else-if="$route.params.mode === 'more'">
      温馨提示:
      <br />1.请使用乘机人的姓名、证件号或者票号进行查询。
      <br />2.变更适用于南航国内客票、国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊国内客票除外。
      <br />3.退票适用于南航国内客票，以及南航官网、APP、微信小程序、微信公众号购买的南航国际客票，团队、里程兑换、职优、政府GP、大客户票等特殊客票除外。
      <br />4.对于以上暂未支持自动退改的客票，请联系南航客服95539办理退改。
    </div>
    <div class="tip" v-else>
      温馨提示:
      <br />请使用乘机人的姓名,证件号或票号如
      <br />7840000000000进行查询
    </div>
  </div>
</template>

<script>
import UpgradeDesc from "@/components/specificPopup/UpgradeDesc";
import { saveLocalData, getLocalData, isApp } from "@/utils/common";

// 缓存数据key
const COMMON_GENERAL_LOGIN_KEY = "COMMON_GENERAL_LOGIN_KEY";

export default {
  name: "GeneralLogin",
  data() {
    let queryNoList = [],
      familyNameList = [],
      givenNameList = [];
    let cacheObj = getLocalData(COMMON_GENERAL_LOGIN_KEY);
    if (cacheObj) {
      queryNoList = cacheObj.queryNoList || [];
      familyNameList = cacheObj.familyNameList || [];
      givenNameList = cacheObj.givenNameList || [];
    }
    return {
      queryNo: "",
      familyName: "",
      givenName: "",
      focusTargetName: "",
      queryNoList,
      familyNameList,
      givenNameList,
      showHandleName: ""
    };
  },
  computed: {
    showTab() {
      return isApp();
    },
    btnDisabled() {
      const { queryNo, familyName, givenName } = this;
      return !(queryNo !== "" && familyName !== "" && givenName !== "");
    }
  },
  methods: {
    enterClick() {
      this.$router.push({
        path: "/query/qrCode",
        query: this.$route.query
      });
    },
    openDescClick() {
      this.$popup({
        title: "升舱说明",
        content: UpgradeDesc,
        btns: null,
        custBody: true
      });
    },
    placeholderClass(name) {
      if (this[name] !== "" || this.focusTargetName === name)
        return "placeholder active";
      return "placeholder";
    },
    onFocus(e) {
      this.focusTargetName = e.target.name;
      this.showHandleName = e.target.name;
    },
    onBlur(e) {
      setTimeout(() => {
        if (this.focusTargetName === e.target.name) {
          this.focusTargetName = "";
          this.showHandleName = "";
        }
      }, 100);
    },
    rightIconClick(name) {
      /* if(name === this.showHandleName) this.showHandleName = "";
      else this.showHandleName = name; */
      this.showHandleName = name;
    },
    clickCacheItem(name, value) {
      this.showHandleName = "";
      this[name] = value;
    },
    saveCache() {
      const maxLength = 3;
      const {
        queryNo,
        familyName,
        givenName,
        queryNoList,
        familyNameList,
        givenNameList
      } = this;
      if (queryNoList.findIndex(item => item === queryNo) === -1) {
        if (queryNoList.length >= maxLength) {
          queryNoList.splice(maxLength - 1, 1);
        }
        queryNoList.unshift(queryNo);
      }
      if (familyNameList.findIndex(item => item === familyName) === -1) {
        if (familyNameList.length >= maxLength) {
          familyNameList.splice(maxLength - 1, 1);
        }
        familyNameList.unshift(familyName);
      }
      if (givenNameList.findIndex(item => item === givenName) === -1) {
        if (givenNameList.length >= maxLength) {
          givenNameList.splice(maxLength - 1, 1);
        }
        givenNameList.unshift(givenName);
      }
      this.queryNoList = queryNoList;
      this.familyNameList = familyNameList;
      this.givenNameList = givenNameList;
      saveLocalData(COMMON_GENERAL_LOGIN_KEY, {
        queryNoList,
        familyNameList,
        givenNameList
      });
    },
    queryClick() {
      if (this.btnDisabled) return;
      this.saveCache();
      const { queryNo, familyName, givenName } = this;
      let { redirect } = this.$route.query;
      if (redirect !== "") {
        const index = redirect.indexOf("urlParams");
        if (index !== -1)
          redirect = redirect.substr(0, index).replace(/&$/, "");
      }
      window.location.href =
        redirect +
        (redirect.includes("?") ? "&" : "?") +
        "urlParams=" +
        encodeURIComponent(
          `mode-${this.$route.params.mode}_` +
            `lastName-${givenName.replace(/\s/g, "")}_` +
            `firstName-${familyName.replace(/\s/g, "")}_` +
            `account-${queryNo.replace(/\s/g, "").toLocaleUpperCase()}`
        );
    }
  }
};
</script>

<style lang="less">
@import "../style/constant.less";
@import "../style/general.less";
.generalLogin {
  @box();
  padding: 27px 20px;
  > .tabs {
    text-align: center;
    > span {
      border: 1px solid #3c88c5;
      color: #3c88c5;
      font-size: @font-sm-size;
      padding: 8px 16px;
      &:first-child {
        border-radius: 6px 0 0 6px;
        border-right-width: 0;
        color: #fff;
        background-color: #3c88c5;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
        border-left-width: 0;
      }
    }
    & + .login-input {
      margin-top: 20px;
    }
  }
  .login-input {
    position: relative;
    border-bottom: 1px solid #d3d3d3;
    height: 50px;
    .cell {
      padding: 0;
      position: relative;
      z-index: 2;
      background-color: transparent;
      height: 50px;
      line-height: 65px;
      font-size: 12px;
      &:not(:last-child)::after {
        border-width: 0;
      }
      .van-field__body {
        height: 50px;
        padding: 10px 0;
      }
      .van-field__left-icon,
      .van-field__right-icon {
        .van-icon {
          font-size: 12px;
        }
      }
      .van-field__right-icon .van-icon {
        color: #333;
      }
    }
    > .placeholder {
      position: absolute;
      left: 0;
      z-index: 1;
      color: #c3c3c9;
      font-size: 14px;
      top: 24px;
      transition: top ease-in-out 0.15s;
      &.active {
        top: 5px;
        font-size: 11px;
        color: #0e95d4;
      }
    }
    > .handle-list {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background-color: #f2f2f2;
      z-index: 9;
      border-radius: 0 0 4px 4px;
      > div {
        height: 48px;
        line-height: 48px;
        padding: 0 15px;
        border-bottom: 1px solid #ccc;
        color: #545454;
        &:last-child {
          border-bottom-width: 0;
        }
      }
    }
  }
  .name-group {
    .login-input {
      width: 160px;
    }
  }
  .split {
    width: 25px;
    text-align: center;
    font-size: 20px;
  }
  .qry-btn {
    width: 180px;
    margin: 24px auto;
    font-size: 12px;
  }
  .tip {
    border-top: 1px solid #ddd;
    font-size: 11px;
    line-height: 1.5;
    margin: 0 -20px;
    color: #000;
    opacity: 0.5;
    padding: 12px 21px 16px;
    .van-icon {
      position: relative;
      top: 2px;
      left: 3px;
      color: #2f93db;
    }
  }
}
</style>